import { useEffect, useRef } from "react";
import { useForm, useWatch } from "react-hook-form";

export const defaultPatient = { id: "", surname: "" };

const usePatientPickerForm = (onChange) => {
  const form = useForm({ defaultValues: defaultPatient });
  const id = useWatch({ control: form.control, name: "id" });
  const surname = useWatch({ control: form.control, name: "surname" });

  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    if (id && surname === null) {
      form.reset();
      onChangeRef.current(defaultPatient);
      return;
    }
    onChangeRef.current(form.getValues());
  }, [id, surname, form]);

  return form;
};

export default usePatientPickerForm;
